import { render, staticRenderFns } from "./referralAndmedical.vue?vue&type=template&id=a6656308&scoped=true"
import script from "./referralAndmedical.vue?vue&type=script&lang=js"
export * from "./referralAndmedical.vue?vue&type=script&lang=js"
import style0 from "./referralAndmedical.vue?vue&type=style&index=0&id=a6656308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6656308",
  null
  
)

export default component.exports